import React, {useState} from "react";

const AttendanceSelector = ({ value, eventID, onChange }) => {
    const [hovered, setHovered] = useState(null);
    const options = [
        {
            key: '1',
            label: '✓',
            activeClass: 'btn-success',
            hoverStyle: { backgroundColor: 'rgba(40, 167, 69, 0.15)', color:'#000' }
        },
        {
            key: '!',
            label: '⏰',
            activeClass: 'btn-warning',
            hoverStyle: { backgroundColor: 'rgba(255, 193, 7, 0.15)', color:'#000' }
        },
        {
            key: 'X',
            label: '✖',
            activeClass: 'btn-danger',
            hoverStyle: { backgroundColor: 'rgba(220, 53, 69, 0.15)', color:'#000' }
        },
        {
            key: '?',
            label: '?',
            activeClass: 'btn-info',
            hoverStyle: { backgroundColor: 'rgba(13, 202, 240, 0.15)', color:'#000' }
        }
    ];

    return (
        <div className="d-flex mt-2">
            {options.map(option => {
                const isActive = value === option.key;
                const isHovered = hovered === option.key;
                const style = !isActive && isHovered ? option.hoverStyle : {};

                return (
                    <button
                        key={option.key}
                        type="button"
                        className={`btn btn-sm me-2 ${isActive ? option.activeClass : 'btn-outline-secondary'}`}
                        style={style}
                        onClick={() => onChange(eventID, isActive ? null : option.key)}
                        // onMouseEnter={() => setHovered(option.key)}
                        // onMouseLeave={() => setHovered(null)}
                    >
                        {option.label}
                    </button>
                );
            })}
        </div>
    );
};

export default AttendanceSelector
